export const REMOVE_FILTERS = 'REMOVE_FILTERS';

export const removeFilters = (context, filterType, filterValues) => ({
  type: REMOVE_FILTERS,
  context,
  filterType,
  filterValues,
});
